import { gql } from "graphql-tag";

import { documentLink, collectionLink } from "~/app/prismic/prismic-fragments";

export const shopByStyleV2 = gql`
  fragment Home_page_v2_shop_by_style_v2 on Home_page_v2SlicesShop_by_style_v2 {
    type
    label
    variation {
      ... on Home_page_v2SlicesShop_by_style_v2Default {
        primary {
          subtitle
        }
        items {
          link_label
          link {
            ...documentLink
            ...collectionLink
          }
        }
      }
    }
  }
  ${documentLink}
  ${collectionLink}
`;
